/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import Subject from './Subject';
import IDisposable from '../lang/IDisposable';

export default class ReadOnlySubject<T> {
  private readonly _subject: Subject<T>;

  constructor(subject: Subject<T>) {
    this._subject = subject;
  }

  get value(): T {
    return this._subject.value;
  }

  subscribe(listener: (value: T) => void): IDisposable {
    return this._subject.subscribe(listener);
  }
}